import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';

import { Text } from '../style';

export const CenteredText = styled(Text)(() =>
  mq({
    textAlign: ['unset', 'unset', 'center', 'center'],
  }),
);
